import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@/styles/index.less"; // global css
import "animate.css/animate.min.css";
import '@/assets/font/font.css';
Vue.config.productionTip = false;
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(ElementUI);
Vue.use(dataV)
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
